<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>
<ngx-spinner bdColor="rgba(51,51,51,0.8)" name="promocao" size="medium" color="#fff" type="ball-scale-multiple">
  <p style="font-size: 20px; color: white">Carregando...</p>
</ngx-spinner>

<app-pesquisar-matricula
  *ngIf="matricula == null"
  [titulo]="'Promoções de Colaboradores'"
  [inputText]="true"
  (colaboradorEmitter)="matriculaListener($event)"
></app-pesquisar-matricula>

<section class="container" *ngIf="matricula != null">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title font-weight-semibold">
        <i
          class="fa fa-arrow-left pr-3 btn"
          aria-hidden="true"
          (click)="retornarTelaInicial()"
          style="cursor: pointer; bottom: 2px"
        ></i
        >Promoções
      </h3>
    </div>
    <div class="card-body">
      <form class="row" [formGroup]="formColaborador">
        <div class="col-md-2 form-group">
          <label class="font-weight-semibold">Matrícula</label>

          <input
            type="text"
            class="form-control"
            placeholder="Matrícula"
            mask="0*"
            formControlName="matricula"
          />

          <span class="form-text" *ngIf="loading"
            >Carregando <i class="fa fa-spinner fa-spin" aria-hidden="false"></i
          ></span>
        </div>

        <div class="col-md-10 form-group">
          <label class="font-weight-semibold">Nome do Colaborador</label>
          <input type="text" class="form-control" placeholder="Nome" formControlName="nome" />
        </div>
      </form>
    </div>
  </div>

  <div class="card d-flex justify-content-center">
    <div class="card-header d-inline-flex justify-content-between">
      <h3 class="card-title font-weight-semibold">Lista de Promoções</h3>
      <div>
        <button type="button" class="btn btn-outline-primary" (click)="downloadPdf()">
          <i class="bi bi-download"></i> Download
        </button>

        <button 
          type="button"
          class="btn btn-outline-primary ml-3"
          (click)="aoAbrirModal()"
          data-toggle="modal"
          data-target="#cadastroPromocaoModal"
        >
          <i class="fa fa-plus"></i> Adicionar Promoção
        </button>
      </div>
    </div>
    <div class="card-body table-responsive mt-2">
      <table
        class="table table-striped border-blue text-left mt-2"
        *ngIf="listaPromocoes.length > 0"
      >
        <thead class="bg-teal-400">
          <tr>
            <th>Sequencial</th>
            <th>Cargo/Função</th>
            <th>Nível</th>
            <th>Data de Início</th>
            <th>Observação</th>
            <th class="text-right" style="padding-right: 125px">Ações</th>
          </tr>
        </thead>

        <tbody *ngFor="let promocao of listaPromocoes; let i = index">
          <tr>
            <td>{{ promocao.Seq }}</td>
            <td>{{ promocao.CodCar || promocao.CodFun }} - {{ promocao.DescCarFun }}</td>
            <td>{{ promocao.CodNiv }}</td>
            <td>{{ formatarData2(promocao.DtInicio) }}</td>
            <td>{{ promocao.Observacao }}</td>
            <td class="d-flex justify-content-center">
              <button
                type="button"
                class="btn btn-outline-info mr-2"
                data-toggle="collapse"
                [attr.data-target]="'#collapseFaltas' + promocao.Seq"
              >
                <i class="fa fa-info"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-primary mr-2"
                (click)="aoAbrirModal(i, promocao.Seq)"
                data-toggle="modal"
                data-target="#cadastroPromocaoModal"
              >
                <i class="fa fa-pencil"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': promocao.Obs === 'N',
                  'btn-primary': promocao.Obs === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#observacoesPromocoesModal"
                (click)="modalObservacoes.abrirModal(promocao)"
              >
                <i class="fa-solid fa-book fa-lg"></i>
              </button>
              <button
                type="button"
                [ngClass]="{
                  'btn-outline-primary': promocao.Documento === 'N',
                  'btn-primary': promocao.Documento === 'S'
                }"
                class="btn mr-2"
                data-toggle="modal"
                data-target="#anexoPromocoesModal"
                (click)="modalAnexo.abrirModal(promocao)"
              >
                <i class="fa fa-file"></i>
              </button>
              <button
                type="button"
                class="btn btn-outline-danger"
                (click)="deletarPromocao(promocao)"
              >
                <i class="fa fa-trash"></i>
              </button>
            </td>
          </tr>
          <td colspan="12" class="collapse px-0" [id]="'collapseFaltas' + promocao.Seq">
            <table class="table table-bordered pb-3">
              <thead class="text-center">
                <tr class="text-center table-primary">
                  <th>Ato</th>
                  <th>Data Comp.</th>
                  <th>Codigo</th>
                  <th>Flag</th>
                  <th>Grupo</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center table-primary">
                  <td>{{ promocao.AtoPro }}</td>
                  <td>{{ formatarData(promocao.DtComp) }}</td>
                  <td>{{ promocao.Cod }}</td>
                  <td>{{ promocao.Flag }}</td>
                  <td>{{ promocao.Grupo }}</td>
                </tr>
              </tbody>
            </table>
          </td>
        </tbody>
      </table>

      <div
        *ngIf="listaPromocoes.length === 0"
        class="p-4 d-flex justify-content-center align-items-center"
      >
        <h6 class="font-weight-semibold">Não há dados de Promoção para esse colaborador.</h6>
      </div>
    </div>
  </div>
</section>

<div class="modal fade" id="cadastroPromocaoModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-promocoes-cadastro
        [cadastro]="cadastroPromocao"
        [colaborador]="colaborador"
        [promocaoAtual]="promocaoAtual"
      ></app-promocoes-cadastro>
    </div>
  </div>
</div>
<div class="modal fade" id="observacoesPromocoesModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-observacoes-ficha-funcional
        (gatilhoAtivado)="buscarPromocoes()"
        [colaborador]="colaborador"
        [tipo]="tipoPagina"
      >
      </app-observacoes-ficha-funcional>
    </div>
  </div>
</div>
<div class="modal fade" id="anexoPromocoesModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <app-anexo
        [pagina]="tipoPagina"
        (gatilhoAtivado)="buscarPromocoes()"
        [matricula]="colaborador?.Matricula"
        [enviarSeparadamente]="true"
        [modal]="true"
      ></app-anexo>
    </div>
  </div>
</div>
